import { render, staticRenderFns } from "./NavbarExpandButton.vue?vue&type=template&id=2a35e1dc&"
import script from "./NavbarExpandButton.vue?vue&type=script&lang=js&"
export * from "./NavbarExpandButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports